__turbopack_context__.v({
  "badge": "Badge-module__tFvXSW__badge",
  "t-gold": "Badge-module__tFvXSW__t-gold",
  "t-neutral": "Badge-module__tFvXSW__t-neutral",
  "t-new": "Badge-module__tFvXSW__t-new",
  "t-sale": "Badge-module__tFvXSW__t-sale",
});
